import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    inputUnderline: {
        '&::after': {
            borderBottom: `0.5px solid ${theme.palette.fg['greySlate']}`
        },
    }
}))
